import clsx from 'clsx';
import BadgeIcon from '@/assets/icons/badge.svg';

export interface OptionImageRadio {
  value: string;
  imageSrc: string;
  classNameImage?: string;
  label?: string;
}

interface BaseImageRadioProps {
  options: OptionImageRadio[];
  name: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const BaseImageRadio: React.FC<BaseImageRadioProps> = ({
  options,
  name,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div
      className={clsx('flex flex-wrap gap-4', {
        'opacity-40 pointer-events-none': disabled,
      })}
    >
      {options.map((option) => (
        <div className="flex flex-col items-center" key={option.value}>
          <label className="relative flex flex-col items-center">
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              className="hidden"
              disabled={disabled}
              onChange={() => onChange(option.value)}
            />
            <img
              src={option.imageSrc}
              alt={option.label}
              className={clsx(
                'cursor-pointer border-2 rounded-lg transition-colors',
                value === option.value ? 'border-brand-500' : 'border-transparent hover:border-brand-200',
                option.classNameImage
              )}
            />
            {value === option.value && (
              <span className="absolute left-2 bottom-2 text-brand-500 bg-white rounded-full">
                <BadgeIcon className="h-5 w-5" />
              </span>
            )}
          </label>
          {option.label && (
            <p className="text-xs font-medium mt-1 text-center">{option.label}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default BaseImageRadio;
